export const ScrollTopOnChange = $anchorScroll => {
  'ngInject';

  return {
    restrict: 'A',

    scope: {
      scrollTopOnChange: '=',
    },

    link($scope) {
      $scope.$watch('scrollTopOnChange', (newValue, oldValue) => {
        if (newValue && newValue !== oldValue) {
          $anchorScroll();
        }
      });
    },
  };
};



// WEBPACK FOOTER //
// ./src/components/ScrollTopOnChange/ScrollTopOnChange.js